import type { Mutation } from 'vuex'
import type { Params, State } from './state'

import actionTypes from './actionTypes'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_DIRECT_SEND_DETAIL]: (state: State, item: any) => {
    state.detail = [...item]
  },

  [actionTypes.SET_PARAMS]: (state: State, item: Params) => {
    state.params = { ...item }
  },

  [actionTypes.SET_TOTAL_COUNT]: (state: State, count: number) => {
    state.total_count = count
  },

  [actionTypes.SET_DIRECT_SEND_CHOOSED_DETAIL]: (state: State, data: Array<any>) => {
    state.choosed_detail = data
  },

  [actionTypes.SET_CORPORATE_NAME]: (state: State, name: string) => {
    state.corporate_name = name
  },
}

export default mutations
